import script from "./GuildChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuildChat.vue?vue&type=script&setup=true&lang=ts"

import "./GuildChat.vue?vue&type=style&index=0&id=d1ca6530&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1ca6530"]])

export default __exports__